import { CtrlType, CtrlProps } from "@yuigoto/ctrl";

/**
 * @type {CtrlProps[]}
 */
export const AuthLoginControl = [
  {
    name: "username",
    label: "E-mail",
    type: CtrlType.EMAIL, 
    required: true,
    requiredMessage: "Este campo é obrigatório",
    emailMessage: "Endereço de e-mail inválido"
  },
  {
    name: "password",
    label: "Senha",
    type: CtrlType.PASSWORD,
    required: true,
    requiredMessage: "Este campo é obrigatório"
  }
];

export const AuthPasswordControl = [
  {
    name: "email",
    label: "E-mail",
    description: "Endereço de e-mail utilizado para se cadastrar e/ou assinar a Glambox.",
    type: CtrlType.EMAIL, 
    required: true,
    requiredMessage: "Este campo é obrigatório",
    emailMessage: "Endereço de e-mail inválido"
  }
];

export const AuthRegisterControl = [
  {
    name: "email",
    label: "E-mail",
    description: "Insira um endereço de e-mail válido",
    type: CtrlType.EMAIL, 
    required: true,
    requiredMessage: "Este campo é obrigatório",
    emailMessage: "Endereço de e-mail inválido"
  },
  {
    name: "firstName",
    label: "Nome",
    type: CtrlType.DEFAULT, 
    required: true,
    requiredMessage: "Este campo é obrigatório"
  },
  {
    name: "lastName",
    label: "Sobrenome",
    type: CtrlType.DEFAULT, 
    required: true,
    requiredMessage: "Este campo é obrigatório"
  },
  {
    name: "password",
    label: "Senha",
    description: "Mínimo de 6, máximo de 20 caracteres",
    type: CtrlType.PASSWORD,
    required: true,
    requiredMessage: "Este campo é obrigatório",
    minLength: 6,
    minLengthMessage: "Sua senha deve conter no mínimo 6 caracteres",
    maxLength: 20,
    maxLengthMessage: "Sua senha deve conter no máximo 20 caracteres"
  },
  {
    name: "passwordConfirmation",
    label: "Confirmação de senha",
    description: "Mínimo de 6, máximo de 20 caracteres",
    type: CtrlType.PASSWORD,
    required: true,
    requiredMessage: "Este campo é obrigatório",
    minLength: 6,
    minLengthMessage: "Sua senha deve conter no mínimo 6 caracteres",
    maxLength: 20,
    maxLengthMessage: "Sua senha deve conter no máximo 20 caracteres"
  },
  {
    name: "newsletterOptIn",
    label: "Aceito receber comunicações da Glambox por e-mail ou outros meios.",
    type: CtrlType.BOOLEAN, 
    value: true, 
    custom: true
  }
];
